export function hasIosUserAgent(): boolean {
  return window.navigator.userAgent.includes('Idealist Mobile App iOS');
}
